import {observable, ObservableMap} from "mobx";
import {O, RunInAction} from "web-vcore";
import {MapState} from "./maps/@MapState.js";
import {CreateAccessor} from "mobx-graphlink";
import {MapToolsState} from "./maps/MapTools.js";
import {format, ignore, parseStore} from "mobx-sync";
import {MapControls} from "../../UI/Maps/MapUI/MapSurface/MapControls.js";
import {format_ObservableMap, SafeDeserializer_ObservableMap, SafeSerializer_ObservableMap} from "../../Utils/General/MobX.js";
import {Timer} from "js-vextensions";
import {store} from "../index.js";

// mostly just as helper for debugging in dev-tools
export const GetOpenMapID = CreateAccessor({ctx: 1}, function() {
	return this.store.main.maps.selectedMapID;
});

export class MapsState {
	//@O accessor subpage = "maps";
	@O accessor selectedMapID: string|n;

	@format_ObservableMap(()=>new MapState(), a=>Object.assign(a, {camPos_0ms: a.camPos_500ms, camZoom_0ms: a.camZoom_500ms} as const satisfies Partial<MapState>))
	@O accessor mapStates = observable.map<string, MapState>();

	@O accessor tools = new MapToolsState();
	@O accessor rightPanelShown = true;

	// make these mobx-observable, since some accessors use these (eg. GetViewportWorldRect)
	@O @ignore accessor mapSurface_3JSContainer: HTMLDivElement|n;
	@O @ignore accessor mapControls_current: MapControls|n;
}

export const GetCurrentMapControls = CreateAccessor({ctx: 1}, function() {
	return this.store.main.maps.mapControls_current;
});